import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { T } from '../../i18n/components/T.js'

interface Props {
  canAddField: boolean
  onAddField: () => void
}
export const FieldsAccordionButton = ({ canAddField, onAddField }: Props) => {
  return (
    <div className="flex items-center">
      <div className="flex-1 truncate font-semibold">
        <T defaultMessage="Fields" id="Generics.CMS.Fields" />
      </div>
      {canAddField && (
        <div
          onClick={e => {
            e.stopPropagation()
            e.preventDefault()
            onAddField()
          }}
        >
          <SvgIcon name="plus" size="lg" />
        </div>
      )}
    </div>
  )
}
